import React, {Component} from 'react';

class WeatherCurrent extends Component {
    render() {
        return (
            <div id= "weather">
                <h1 id="city">{this.props.name}</h1>
                <img id="icon" alt="" src={"http://openweathermap.org/img/w/" + this.props.icon + ".png"}/>
                <h3 id="temp">{Math.round(this.props.temp)} °F</h3>
                <h3 id="short">{this.props.short}</h3>
                <h5 id="long">{this.props.long}</h5>
            </div>
        );
    }
}

export default WeatherCurrent;



// WEBPACK FOOTER //
// ./src/WeatherCurrent.jsx